import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * ExaminationModal のスタイル
 */
export const examinationModalStyle = tv({
    slots: {
        base: ['flex flex-col items-center justify-center gap-24', 'py-40 px-16'],
        text: [textStyle({ color: 'base', size: 'sm' }), 'text-center'],
        title: [textStyle({ color: 'base', isBold: true, size: 'lg' })],
    },
});
